module.exports = __webpack_public_path__ + "img/ccdszhibotop.2b973225.png";